<template>
  <div id="expiredRouteFilter">
    <span
      class="expire-selector"
      @click.stop="filterClicked()"
    >{{ activeFilter.name }}</span>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      selectedFilter: 'show'
    }
  },

  computed: {
    activeFilter() {
      return this.filters.find(item => item.value === this.selectedFilter)
    }
  },

  methods: {
    filterClicked() {
      const newFilter = this.filters.find(item => item.value !== this.selectedFilter)
      this.selectedFilter = newFilter.value
      this.$emit('expire-filter-clicked', newFilter)
    }
  }
}
</script>

<style lang="sass" scoped>
#expiredRouteFilter
  margin: 2rem auto
  float: right
  span
    display: block
    cursor: pointer
    margin-bottom: 0.5rem
    font-size: 1.5rem
    color: $hwayzBrandGold
    &.selected--text
      color: $hwayzBrandBlue
</style>
